import { useEffect, useState } from 'react';
import { getSession, type Session } from './lib/session';
import { ClientProvider } from './lib/ClientContext';
import { Login } from './ui/Login';
import { AppShell } from './ui/AppShell';

export function App() {
  const [session, setSession] = useState<Session | null>(null);
  const [ready, setReady] = useState(false);
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    getSession()
      .then(setSession)
      .finally(() => setReady(true));
  }, []);

  if (!ready) return <div className="empty">Loading…</div>;
  if (!session) {
    return (
      <Login
        notice={expired ? 'Your session expired — please sign in again.' : ''}
        onLogin={(s) => {
          setExpired(false);
          setSession(s);
        }}
      />
    );
  }
  return (
    <ClientProvider
      session={session}
      onAuthLost={() => {
        setExpired(true);
        setSession(null);
      }}
    >
      <AppShell onLogout={() => setSession(null)} />
    </ClientProvider>
  );
}
